interface Props {
  legenda: string;
  ajuda?: string;
  valor: boolean;
  onChange: (valor: boolean) => void;
  /** `name` do grupo de opções (a tela pode ter várias perguntas ao mesmo tempo). */
  name: string;
  rotuloSim?: string;
  rotuloNao?: string;
}

/**
 * Pergunta de Sim ou Não com duas opções lado a lado e o estado sempre escrito (melhor que um
 * interruptor sem rótulo). Usa botões de rádio de verdade: teclado e leitor de tela funcionam.
 */
export function EscolhaSimNao({
  legenda,
  ajuda,
  valor,
  onChange,
  name,
  rotuloSim = "Sim",
  rotuloNao = "Não",
}: Props) {
  return (
    <fieldset className="flex flex-col gap-2">
      <legend className="text-sm font-semibold text-text">{legenda}</legend>
      {ajuda && <p className="text-xs text-muted">{ajuda}</p>}
      <div className="grid grid-cols-2 gap-2">
        {[true, false].map((opcao) => (
          <label key={String(opcao)} className="relative block">
            <input
              type="radio"
              name={name}
              checked={valor === opcao}
              onChange={() => onChange(opcao)}
              className="peer sr-only"
            />
            <span className="flex min-h-11 cursor-pointer items-center justify-center rounded-md border border-border bg-surface-2 px-3 text-center text-sm font-semibold text-muted transition-colors peer-checked:border-primary peer-checked:bg-primary peer-checked:text-on-primary peer-focus-visible:ring-2 peer-focus-visible:ring-primary">
              {opcao ? rotuloSim : rotuloNao}
            </span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
